// home-editor-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A largura mudou e a arte recomendada agora é outra. Vale trocar a imagem.": "El ancho cambió y el arte recomendado ahora es otro. Conviene cambiar la imagen.",
    "Bloco de imagem": "Bloque de imagen",
    "Uma arte clicável, em linha inteira ou meia linha.": "Un arte clicable, en fila completa o media fila.",
};

export default catalogo;
